// extracted by mini-css-extract-plugin
module.exports = {"noDataContainer":"geofence-map_noDataContainer__1hJIJ","mapContainer":"geofence-map_mapContainer__1MWWd","box":"geofence-map_box__16r-6","title":"geofence-map_title__3ScFU"};